/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import type ProcessError from 'linced-app/models/media/process-error';
import type Person from 'linced-app/models/person';
import type School from 'linced-app/models/school';

// Proto: media.Status.
export default class Status extends Model {
  declare [Type]: 'media/status';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // updateTime is the last time the resource was modified in seconds from
  // the epoch.
  @attr('number')
  declare updateTime: number | undefined;

  // schoolId is the unique identifier of the school.
  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  // campusId is the unique identifier of the School's Campus.
  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  // requesterId is the personId of the user who created the status resource.
  @belongsTo('person', { async: true, inverse: null })
  declare requesterId: AsyncBelongsTo<Person>;

  // jurisdiction maps to the jurisdictional educational authority.
  @attr('number', { defaultValue: 0 })
  declare jurisdiction: EnumValue<typeof Jurisdiction> | 0; // Jurisdiction

  // process is the specific type of process that is being performed.
  @attr('number', { defaultValue: 0 })
  declare process: number; // ProcessType

  // status contains the current in flight status of the request.
  @attr('number', { defaultValue: 1 })
  declare status: number; // State

  // count is the number of records to be processed. (Server-side calculated)
  @attr('number', { defaultValue: 0 })
  declare count: number;

  // processed is the number of records of count that have been processed.
  @attr('number', { defaultValue: 0 })
  declare processed: number;

  // storageKey is the generated file name under which the file is actually
  // stored via minio.
  @attr('string', { defaultValue: '' })
  declare storageKey: string;

  // errors contains any reported issues for people while processing.
  // TS-BUG: this replaces Model.errors, so a save cannot record validation
  // errors (same as common cron/process-monitor, HE-161).
  @fragmentArray('media/process-error')
  // @ts-expect-error the proto errors field replaces the Model errors.
  declare errors: FragmentArray<ProcessError>;
}
